// Module
var code = "<div> <div> <numbers type=\"money\" :value=\"stuffItem.salary_amount\"></numbers> </div> <div> <span>{{salaryPeriodTypeList[stuffItem.salary_period]}}</span> </div> </div>";
// Exports
module.exports = code;